import * as yup from 'yup';

export const createManualMatchValidation = yup.object().shape({
  audio: yup.mixed().required(),
  datetime: yup.string().required(),
  score: yup.number().min(0).max(100),
  playedDuration: yup.number(),
});
